import SafeHtml from "../../content/SafeHtml";
import { Link } from "react-router-dom";
import css from "./userCabinet.module.css";
import useContentDoc from "../../hooks/useContentDoc";

const BlockLibrarian = () => {
  // тягнемо документ siteContent/blockLibrarian
  const { data: c } = useContentDoc("siteContent", "blockLibrarian");

  if (!c || c.enabled === false) return null;

  return (
    <div className={css.readerUserWrap}>
      <div className={css.readerUserWrapSmall}>
        {/* H1 + інтро */}
        {(c.introTitle || c.introHtml) && (
          <>
            {c.introTitle && (
              <h1 className={css.aboutCompanyH1}>{c.introTitle}</h1>
            )}
            {c.introHtml && (
              <SafeHtml
                className={css.paragInWrapBig}
                html={c.introHtml}
              />
            )}
          </>
        )}

        {/* Опікунська рада — лінк */}
        {c.guardianForm?.url && c.guardianForm?.label && (
          <h1 className={css.aboutCompanyH1}>
            <a
              className={css.aboutCompanyH1}
              href={c.guardianForm.url}
              target="_blank"
              rel="noreferrer noopener"
            >
              {c.guardianForm.label}
            </a>
          </h1>
        )}

        {/* Опікунська рада — текст */}
        {c.guardianTextHtml && (
          <SafeHtml
            className={css.paragInWrapBig}
            html={c.guardianTextHtml}
          />
        )}

        {/* Рукописи (заголовок + route + текст) */}
        {(c.manuscripts?.title || c.manuscripts?.route) && (
          <h1 className={css.aboutCompanyH1}>
            {c.manuscripts?.route ? (
              <Link className={css.aboutCompanyH1} to={c.manuscripts.route}>
                {c.manuscripts.title || "Рукописи"}
              </Link>
            ) : (
              c.manuscripts?.title
            )}
          </h1>
        )}
        {c.manuscriptsTextHtml && (
          <SafeHtml
            className={css.paragInWrapBig}
            html={c.manuscriptsTextHtml}
          />
        )}

        {/* Каталог для бібліотек (банер) */}
        {(c.catalogBanner?.buttonLabel ||
          c.catalogBanner?.noteHtml ||
          c.catalogBanner?.url) && (
          <div className={css.catalogBannerWr}>
            {c.catalogBanner?.noteHtml && (
              <SafeHtml
                className={css.paragInWrapBig}
                html={c.catalogBanner.noteHtml}
              />
            )}

            {c.catalogBanner?.url && c.catalogBanner?.buttonLabel && (
              <a
                className={css.pdfButton}
                href={c.catalogBanner.url}
                target="_blank"
                rel="noreferrer noopener"
              >
                <div className={css.pdfButton}>
                  {c.catalogBanner.buttonLabel}
                </div>
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default BlockLibrarian;
